import { mode } from '@chakra-ui/theme-tools';

export const accordionStyles = {
	components: {
		Accordion: {
			baseStyle: (props: any) => ({
				container: {
					// Sin efectos visuales - solo texto
					borderRadius: '0',
					bg: 'transparent',
					backdropFilter: 'none',
					border: 'none',
					borderColor: 'transparent',
					boxShadow: 'none',
					transition: 'all 0.6s cubic-bezier(0.4, 0, 0.2, 1)',
					_hover: {
						boxShadow: 'none',
					}
				},
				button: {
					borderRadius: '0',
					transition: 'all 0.6s cubic-bezier(0.4, 0, 0.2, 1)',
					color: mode('gray.800', 'white')(props),
					fontWeight: '500',
					border: 'none',
					borderColor: 'transparent',
					boxShadow: 'none',
					_hover: {
						bg: 'transparent',
					},
					_expanded: {
						bg: 'transparent',
						color: mode('gray.900', 'white')(props),
					},
					_focus: {
						boxShadow: 'none',
					}
				},
				panel: {
					px: 4,
					py: 3,
					borderRadius: '0 0 12px 12px',
				}
			})
		}
	}
};
